export const FAMILY_DISCUSSION_PROMPTS: string[] = [
  "What's something that made you laugh today?",
  "If you could invent a new holiday, what would it be?",
  "What's a small thing someone did for you this week that you appreciated?",
  "If we could go anywhere together tomorrow, where would we go?",
  "What's a skill you'd like to learn this year?",
  "What's the best meal you've ever had and why?",
  "If you could have any superpower for one day, what would you do with it?",
  "What's something you're looking forward to next week?",
  "What's the kindest thing you saw someone do today?",
  "If our family had a flag, what would be on it?",
  "What's one thing you'd like to do more of as a family?",
  "What's a song that always makes you happy?",
  "If you could be any age for a week, which age and why?",
  "What's something you used to be scared of but aren't anymore?",
  "What's the best gift you've ever received (or given)?",
  "If you opened a restaurant, what kind of food would it serve?",
  "What's something weird that you really enjoy?",
  "What was your favorite part of today?",
  "If you could only eat three foods for a year, what would they be?",
  "What's a place you've never been that you'd love to visit?",
  "If you could meet anyone in history, who would it be?",
  "What's a tradition we should start?",
  "What's something nice you noticed about someone in this room?",
  "If you wrote a book, what would it be about?",
  "What's the last thing that surprised you?",
  "What's something hard you did this week that you're proud of?",
  "If you could trade places with anyone for a day, who?",
  "What's something you'd like to be remembered for?",
  "What's the funniest dream you've ever had?",
  "If you ran the world for a week, what's the first thing you'd change?",
  "What's a smell that takes you back to a memory?",
  "What's a question you wish someone would ask you?",
  "If you started a YouTube channel tomorrow, what would it be about?",
  "What's a compliment you got that you still think about?",
  "What's something small that brings you a lot of joy?",
  "If you could pick a different name for yourself, what would it be?",
  "What's the most beautiful place you've ever seen?",
  "What's a movie you could watch again and again?",
  "If you could solve one problem in the world, which one?",
  "What's a hobby you'd try if you knew you wouldn't be bad at it?",
  "What's the best advice anyone has ever given you?",
  "If you opened a store, what would it sell?",
  "What's something you're better at than most people realize?",
  "What was your favorite class or subject in school, and why?",
  "If you could speak any language fluently right now, which?",
  "What's a question you used to wonder about as a kid?",
  "What's a chore you secretly don't mind doing?",
  "If you had a robot helper, what would you make it do first?",
  "What's something you'd love to learn from someone in this family?",
  "What was the highlight of your week?",
  "What's a tiny adventure we could do this weekend?",
  "What's a memory from this year that you'll always keep?",
  "If you could relive one day this year, which?",
  "What's something you want to try cooking together?",
  "What's a place in our home you love and why?",
  "What's a goal you have for next month?",
  "If you could pause time, what would you do with the extra hours?",
  "What's the best thing about being part of our family?",
  "What's something you've changed your mind about recently?",
  "What's a problem you're working on right now?",
  "What's the kindest thing you could do for someone tomorrow?",
  "If you could ask a wise old version of yourself one question, what?",
  "What's the most fun you've ever had?",
  "What's a silly tradition you'd like us to start?",
  "If you could plant a garden, what would you grow?",
  "What's a sound that calms you down?",
  "If money didn't matter, what would you spend your time on?",
  "What's a book or show that changed how you think?",
  "What's the bravest thing you've ever done?",
  "What's something you're grateful for right now?",
  "If you could redo any room in our house, which?",
  "What's a small luxury that you really enjoy?",
  "What's a hard thing that turned out to teach you something good?",
  "What was the best thing someone said to you this week?",
  "If you could invent a new family rule, what would it be?",
  "What's a tradition from your childhood you'd like to keep?",
  "What's a hope you have for next year?",
  "If you could go on a road trip anywhere, where to?",
  "What's a thing you've never told anyone in this family?",
  "What's a movie scene that always makes you cry — happy or sad?",
  "If you had a magic wand for one wish, what would you wish?",
  "What's the best part of right now?",
]
